<template>
  <div>
    <v-alert
      class="elevation-2 rounded-lg"
      prominent
      v-for="(condition, i) in freetext"
      :key="i"
    >
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center">
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-text-field
                  label="คำตอบข้อความ"
                  disabled
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-text-field
                  v-model="condition.defaultCondition.score"
                  type="number"
                  solo
                  dense
                  label="คะแนน"
                  :rules="[
                    $store.getters.ScoreRule(condition.defaultCondition.score),
                  ]"
                >
                  <template #prepend> คะแนน </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="d-flex align-center"
                v-if="!condition.hascompute"
              >
                <v-autocomplete
                  v-model="condition.defaultCondition.nextQuestionID"
                  :items="Jump"
                  label="เลือกคำถาม"
                  solo
                  dense
                  color="#0D8EEE"
                  item-text="questionLabel"
                  item-value="questionID"
                  :rules="[
                    $store.getters.TextRule(
                      condition.defaultCondition.nextQuestionID
                    ),
                  ]"
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                    maxHeight: 200,
                  }"
                >
                  <template #prepend> คำถามต่อไป </template>
                  <template v-slot:item="{ item }">
                    <v-list-item
                      @click="
                        condition.defaultCondition.nextQuestionID =
                          item.questionID
                      "
                      style="max-width: 400px"
                    >
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span class="d-flex align-center">
                            {{ item.questionLabel }}
                          </span>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-radio-group
                  v-model="condition.hascompute"
                  row
                  label="คำนวณคะแนน"
                >
                  <v-radio label="มี" color="info" :value="true"></v-radio>
                  <v-radio label="ไม่มี" color="info" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div v-if="condition.hascompute">
          <div>
            <ComputeScore
              :computeCondition="condition.computeCondition"
              :Jump="Jump"
              :NextQuestion="NextQuestion"
            />
          </div>
        </div>
      </v-container>
    </v-alert>
  </div>
</template>

<script>
import ComputeScore from "./ComputeScore";
export default {
  props: ["freetext", "Jump", "freetext_notmatch", "NextQuestion"],
  components: { ComputeScore },
  computed: {
    operationlist() {
      return this.$store.state.operation;
    },
  },
};
</script>

<style lang="scss" scoped></style>
